import { Button } from '@/components/ui/button';
import { Mail, Phone } from 'lucide-react';

export function CTASection() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-br from-vitapink to-vitapink-700 text-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-6xl font-bold mb-6">
          Faça Seu Pré-Cadastro
        </h2>
        
        <p className="text-xl md:text-2xl mb-12 text-vitapink-100">
          Para utilizar nossas novas ferramentas e sistemas de gestão
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button
            size="lg"
            variant="secondary"
            className="bg-white text-vitapink hover:bg-gray-100 px-8 py-6 text-lg font-bold"
            onClick={() => window.open('https://wa.me/5567991768713?text=Olá!%20Quero%20fazer%20parte%20do%20grupo%20de%20membros', '_blank')}
          >
            Faça Parte do Grupo de Membros
          </Button>
          
          <Button
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/10 px-8 py-6 text-lg font-bold"
            onClick={() => window.open('https://wa.me/5567991768713', '_blank')}
          >
            Fale Conosco
          </Button>
        </div>

        <p className="text-sm text-vitapink-100 mb-8">
          ⏰ Vagas limitadas para os primeiros membros
        </p>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer id="contato" className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo and About */}
          <div id="sobre">
            <img
              src="/logo-vitacode.png"
              alt="VitaCode"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed">
              VitaCode Software House e Gestora de Mídias Sociais
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-vitapink">Contato</h3>
            <div className="space-y-3">
              <a
                href="https://wa.me/5567991768713"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>(67) 9 9176-8713</span>
              </a>
              <a
                href="mailto:brunons2014@gmail.com"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>brunons2014@gmail.com</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-vitapink">Serviços</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Desenvolvimento Web</li>
              <li>Gestão de Mídias Sociais</li>
              <li>Edição de Vídeo</li>
              <li>Sistemas de Gestão</li>
              <li>Tráfego Pago</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
          <p>© 2026 VitaCode. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
